import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import get from 'lodash/get'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import { Button, Container, Row, Col, Modal, ModalHeader } from 'reactstrap'
import {
  authAction,
  modalAction,
  consentAction,
  employeeAction,
  masterDataAction,
  consentLogAction,
} from './../../actions/'
import {
  authSelector,
  modalSelector,
  consentSelector,
  masterDataSelector,
  consentLogSelector,
} from './../../selectors'
import { searchConsents } from '../../function'
import CustomModal from '../../components/modal'
import Searchbar from '../../components/searchbar'
import withLayout from '../../helpers/withLayout'
import EditConsent from './edit'
import ListConsent from './list'
import ConsentManagementForm from '../../components/consent-management'
import CustomModalMessage from '../../components/modal-message'
import { EmployeeListConsent } from '../../components/consent-management/employee-table'
import { getListUser } from '../../selectors/employee/employee-selector'

class ConsentManagementPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      edit: false,
      span: false,
      title: '',
      description: '',
      id: '',
      user_type: '',
      search: '',
      defaultCompanys: [],
      companys: [],
      showConsent: false,
      consent_create_data: {},
      submitSent: false,
    }
    this.handleClickEdit = this.handleClickEdit.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSpan = this.handleSpan.bind(this)
    this.showForm = this.showForm.bind(this)
    this.cancelForm = this.cancelForm.bind(this)
    this.showDiscard = this.showDiscard.bind(this)
    this.cancelDiscard = this.cancelDiscard.bind(this)
    this.showDelete = this.showDelete.bind(this)
    this.cancelDelete = this.cancelDelete.bind(this)
    this.submitForm = this.submitForm.bind(this)
    this.cancelAlert = this.cancelAlert.bind(this)
    this.showSave = this.showSave.bind(this)
    this.cancelSave = this.cancelSave.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleModelChange = this.handleModelChange.bind(this)
  }

  componentDidMount() {
    this.props.getAuth(localStorage.getItem('access_token'))
    this.props.getEmployeeList(localStorage.getItem('access_token'))
    this.props.getMasterData(localStorage.getItem('access_token'))
    this.props.listConsentLog(localStorage.getItem('access_token'))
  }

  componentWillReceiveProps(nextProps) {
    if (get(nextProps, 'listCompanyData') && this.state.search === '') {
      this.setState({
        companys: get(nextProps, 'listCompanyData'),
        defaultCompanys: get(nextProps, 'listCompanyData'),
      })
    }
    if (get(nextProps, 'consentCreate.consentCreate')) {
      this.props.showModal(
        'company',
        get(nextProps, 'consentCreate.status'),
        get(nextProps, 'consentCreate.message')
      )
      this.props.listCompany(localStorage.getItem('access_token'))
      this.props.listConsentLog(localStorage.getItem('access_token'))
      this.props.resetCreateCompany()
      this.props.resetEditConsentLog()
    }
    if (get(nextProps, 'consentEdit.consentEdit')) {
      this.setState({
        edit: false,
      })
      this.props.showModal(
        'company',
        get(nextProps, 'consentEdit.status'),
        get(nextProps, 'consentEdit.message')
      )
      if (get(nextProps, 'consentEdit.status') === 200 && this.state.edit === true) this.showSave()
      this.props.listCompany(localStorage.getItem('access_token'))
      this.props.listConsentLog(localStorage.getItem('access_token'))
      this.props.resetEditCompany()
      this.props.resetEditConsentLog()
      this.handleClickEdit(false, '')
    }
    if (get(nextProps, 'consentDeactivate.consentDeactivate')) {
      this.props.showConfirm(
        'deleteCompany',
        get(nextProps, 'consentDeactivate.status'),
        get(nextProps, 'consentDeactivate.message')
      )
      this.props.listCompany(localStorage.getItem('access_token'))
      this.props.resetDeactivateCompany()
    }
    if (get(nextProps, 'exportURL')) {
      window.open(get(nextProps, 'exportURL'), 'blank')
      this.props.resetExportCompany()
    }
  }
  handleClickSearch() {
    this.setState({ companys: get(this.state, 'defaultCompanys').filter(searchConsents, this.state.search) })
  }
  handleSearch(e) {
    if (e.keyCode === 13) this.handleClickSearch()
    else if (e.target.value === '') this.setState({ companys: get(this.state, 'defaultCompanys'), search: '' })
    else this.setState({ search: e.target.value })
  }
  handleClickEdit(editCompany, company_id) {
    this.setState({
      edit: editCompany,
      id: company_id,
    })
  }
  handleInput(e) {
    this.setState({ [e.target.name]: e.target.value })
  }
  handleModelChange(e) {
    this.setState({
      description: e,
    })
  }
  handleSpan(spanList) {
    this.setState({ span: spanList })
  }
  showSave() {
    this.props.showConfirm('confirmSave', 'Saved Successfully', 'Your consent information had been saved.')
  }
  cancelSave() {
    this.props.hideConfirm('confirmSave')
  }
  showDelete() {
    this.props.showConfirm('confirmDelete', 'Delete Comfirmation', 'Are you sure to delete ?')
  }
  cancelDelete() {
    this.props.hideConfirm('confirmDelete')
  }
  showDiscard() {
    this.props.showConfirm('confirmDiscard', 'Discard Changes', 'Are you sure you want to discard all changes ?')
  }
  cancelDiscard() {
    this.props.hideConfirm('confirmDiscard')
  }
  showForm() {
    this.handleClickEdit(false, '')
    this.handleSpan(false)
    this.props.showModal('ConsentManagementForm')
  }
  cancelForm() {
    this.setState({ description: '' })
    // this.props.hideModal('EmployeeListConsent')
    this.props.hideModal('ConsentManagementForm')
  }
  cancelAlert() {
    this.props.hideModal('ConsentManagementForm')
  }
  submitForm() {
    this.props.createCompany(
      {
        title: this.state.title,
        description: this.state.description,
        user_type: this.state.user_type,
        status: 'false',
      },
      localStorage.getItem('access_token')).then(data => {
      if (data.error === true) {
        this.setState({ consent_create_data: { _id: '' } })
      } else {
        this.setState({ consent_create_data: data.payload.createdConsent })
      }
    }).catch(error => {
    })
  }

  openConsentModal = () => {
    this.props.createCompany(
      {
        title: this.state.title,
        description: this.state.description,
        user_type: this.state.user_type,
        status: 'false',
      },
      localStorage.getItem('access_token')).then(data => {
      if (data.error === true) {
        this.setState({ consent_create_data: { _id: '' } })
        this.setState({ showConsent: false })
      } else {
        this.setState({ consent_create_data: data.payload.createdConsent })
        this.setState({ showConsent: true })
      }
    }).catch(error => {
    })
    this.props.resetCreateCompany()
  }
  closeConsentModal = () => {
    this.setState({
      showConsent: false,
    }
    )
  }
  render() {
    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectCompany.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
      || get(this.props, 'redirectCompany.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }

    const button = (
      <div>
        <NewButton color="success" onClick={ this.submitForm }>Save</NewButton>
        <NewButton color="success" onClick={ this.openConsentModal }>Save & Send</NewButton>
      </div>
    )
    const buttonOK = (
      <div>
        <NewButton color="info" onClick={ this.cancelSave }>OK</NewButton>
      </div>
    )
    const isFetching = get(this.props, 'getIsFetching')
    const closeBtn = <button className="close" onClick={ this.closeConsentModal }>&times;</button>
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          export={ () => this.props.exportCompany(localStorage.getItem('access_token')) }
          toggleCreate={ this.showForm }
          handleSearch={ this.handleSearch }
          handleClickSearch={ this.handleClickSearch }
          search={ this.state.search }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        {
          get(this.props, 'modalType') === 'company' &&
            <CustomModal
              hide={ this.cancelAlert }
              show={ get(this.props, 'modalType') === 'company' }
              type={ get(this.props, 'modalStatus') }
              message={ get(this.props, 'modalMessage') }
            />
        }
        {
          get(this.props, 'confirmType') === 'confirmSave' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'confirmSave' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        {
          get(this.props, 'confirmType') === 'deleteCompany' &&
          <CustomModalMessage
            hide={ this.cancelSave }
            show={ get(this.props, 'confirmType') === 'deleteCompany' }
            type={ get(this.props, 'confirmStatus') }
            message={ get(this.props, 'confirmMessage') }
            button={ buttonOK }
          />
        }
        <Row noGutters>
          <Col>
            <ListConsent
              handleClickEdit={ this.handleClickEdit }
              handleSpan={ this.handleSpan }
              span={ this.state.span }
              companys={ this.state.companys }
              table={ 1 }
            />
          </Col>
          {
            // this.state.span && <Col>
            <Modal size='lg' isOpen={ this.state.span } toggle={ this.cancelForm }>
              <EditConsent
                edit={ this.state }
                handleClickEdit={ this.handleClickEdit }
                handleSpan={ this.handleSpan }
                cancelForm={ this.cancelForm }
                showDelete={ this.showDelete }
                cancelDelete={ this.cancelDelete }
                showDiscard={ this.showDiscard }
                cancelDiscard={ this.cancelDiscard }
                confirm={ get(this.props, 'confrimType') }
                confirmStatus={ get(this.props, 'confirmStatus') }
                confirmType={ get(this.props, 'confirmType') }
                confirmMessage={ get(this.props, 'confirmMessage') }
                consent={ get(this.props, 'listCompanyData') }
                masterData={ this.props.listMasterData }
                openConsentModal={ this.openConsentModal }
              />
            </Modal>
          }
        </Row>
        <Modal size='lg' isOpen={ get(this.props, 'modalType') === 'ConsentManagementForm' } toggle={ this.cancelForm }>
          <ConsentManagementForm
            create={ true }
            button={ button }
            submitForm={ this.submitForm }
            handleClickEdit={ this.handleClickEdit }
            handleInput={ this.handleInput }
            handleModelChange={ this.handleModelChange }
            description={ this.state.description }
            title={ this.state.title }
            user_type={ this.state.user_type }
            confirm={ get(this.props, 'modalType') }
            cancelForm={ this.cancelForm }
            modalStatus={ get(this.props, 'modalStatus') }
            modalType={ get(this.props, 'modalType') }
            submitSent={ this.state.submitSent }
            closeBtn={ closeBtn }
            openConsentModal={ this.openConsentModal }
          />
        </Modal>
        <Modal isOpen={ this.state.showConsent } size='lg'>
          <ModalHeader close={ closeBtn }>Add Employee List</ModalHeader>
          <EmployeeListConsent
            data={ this.props.employeeList }
            masterData={ this.props.listMasterData }
            consentData={ this.state.consent_create_data._id }
            submitSent={ this.state.submitSent }
            cancelSent={ this.cancelForm }
            closeBtn={ this.closeConsentModal }
            style={ { 'max-height': 'calc(100vh - 210px)', 'overflow-y': 'auto' } }
          />
        </Modal>
      </Wrapper>
    )
  }
}

ConsentManagementPage.propTypes = {
  createCompany: PropTypes.func.isRequired,
  resetCreateCompany: PropTypes.func.isRequired,
  listCompany: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  resetEditCompany: PropTypes.func.isRequired,
  resetDeactivateCompany: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  getEmployeeList: PropTypes.func.isRequired,
  getMasterData: PropTypes.func.isRequired,
  listConsentLog: PropTypes.func.isRequired,
  resetEditConsentLog: PropTypes.func.isRequired,
}
const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  getIsFetching: consentSelector.getIsFetching,
  redirectAuth: authSelector.redirectAuth,
  redirectCompany: consentSelector.redirectCosent,
  consentCreate: consentSelector.getCreateConsentData,
  consentEdit: consentSelector.getEditConsentData,
  consentDeactivate: consentSelector.getDeactivateConsentData,
  listCompanyData: consentSelector.getListConsent,
  exportURL: consentSelector.getExportURL,
  employeeList: getListUser,
  listMasterData: masterDataSelector.getGetMasterData,
  consentLogList: consentLogSelector.getConsentLog,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  createCompany: consentAction.createConsent,
  resetCreateCompany: consentAction.resetCreateConsent,
  resetEditCompany: consentAction.resetEditConsent,
  resetDeactivateCompany: consentAction.resetDeactivateConsent,
  listCompany: consentAction.getConsentList,
  exportCompany: consentAction.exportConsent,
  resetExportCompany: consentAction.resetExportUser,
  getEmployeeList: employeeAction.getUser,
  getMasterData: masterDataAction.getMasterData,
  listConsentLog: consentLogAction.getConsentLog,
  resetEditConsentLog: consentLogAction.resetEditConsentLog,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withLayout(ConsentManagementPage))

const Wrapper = styled(Container)`
  padding: 0px;
  background-color: #F1F1F1;
`
const NewButton = styled(Button)`
  width: 150px;
  height: 50px;
  margin: 10px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/consent-management/index.js